import axios from "axios";
import * as firebase from "firebase/app";
import "firebase/auth";
import { User } from "@/models/user";
import Cellar from "@/models/cellar";
// @ts-ignore
import { JsonApiDataStore } from "../../../node_modules/jsonapi-datastore";
// import { Locales } from "../../models/locales";
import { configService } from "../index";

const dataStore = new JsonApiDataStore();

export function fetchUserDetails(
  token?: string,
  data?: Object,
  authMode?: string
): Promise<any> {
  const buildUserDetailsPromise = () =>
    axios.get(
      configService.profile,
      token ? { headers: { Authorization: `bearer ${token}` } } : undefined
    );
  const buildCreateUserPromise = () =>
    axios.post(configService.profile, { data: { attributes: data } });
  const currentUser = firebase.auth().currentUser;
  const buildDeleteUserRejectedPromise = (fromError: any) => {
    if (currentUser) currentUser.delete().then(() => Promise.reject(fromError));
  };
  if (authMode === "signup") {
    return buildCreateUserPromise()
      .then(
        (response: any): User => {
          dataStore.reset();
          dataStore.sync(response.data);
          const item = dataStore.findAll("user");
          return new User().deserialize(item[0]);
        }
      )
      .catch((error: any) => buildDeleteUserRejectedPromise(error));
  }
  return buildUserDetailsPromise()
    .then(
      (response: any): User => {
        dataStore.reset();
        dataStore.sync(response.data);
        const item = dataStore.findAll("user");
        // console.warn("user: ", item);
        return new User().deserialize(item[0]);
      }
    )
    .catch((error: any) => {
      throw error;
    });
}

export function signUp(email: string, password: string) {
  return firebase.auth().createUserWithEmailAndPassword(email, password);
}

export function signIn(email: string, password: string) {
  return firebase.auth().signInWithEmailAndPassword(email, password);
}

//   resetPassword: (email: string): Promise<void> =>
//     Promise.resolve()
//       .then((): Promise<any> => firebase.auth().sendPasswordResetEmail(email))
//       .then((): Promise<void> => Promise.resolve()),
//   setNewPassword: (creds: any): Promise<void> =>
//     Promise.resolve()
//       .then((): Promise<any> =>
//         firebase.auth().confirmPasswordReset(creds.code, creds.password)
//       )
//       .then((): Promise<void> => Promise.resolve()),
export function signOut(): Promise<void> {
  return firebase.auth().signOut();
}
//   fetchLocales: (): Promise<Locales[]> =>
//     axios
//       .get(ConfigService.instance.languages)
//       .then((response: *): Locales[] =>
//         response.data.data.map((locale: *): Locales =>
//           new Locales().deserialize(locale)
//         )
//       )
// };
